module.exports = __webpack_public_path__ + "img/default-image.b6065e3f.jpg";